import { useState } from 'react';

const ZONAS = [
  'Machalí', 'Rancagua', 'Sewell',
  'Santiago Centro', 'Pudahuel', 'La Florida',
  'Maipú', 'Puente Alto', 'San Bernardo',
];

const RRSS = [
  { campo: 'instagram', label: 'Instagram',  placeholder: 'https://instagram.com/mi-recinto'  },
  { campo: 'facebook',  label: 'Facebook',   placeholder: 'https://facebook.com/mi-recinto'   },
  { campo: 'tiktok',    label: 'TikTok',     placeholder: 'https://tiktok.com/@mi-recinto'    },
  { campo: 'web',       label: 'Sitio web',  placeholder: 'https://www.mi-recinto.cl'         },
];

export default function StepDatosRecinto({ datos, onNext, onBack }) {
  const [form, setForm] = useState({
    nombreRecinto: datos.nombreRecinto || '',
    direccion:     datos.direccion     || '',
    ciudad:        datos.ciudad        || '',
    zona:          datos.zona          || '',
    descripcion:   datos.descripcion   || '',
    instagram:     datos.instagram     || '',
    facebook:      datos.facebook      || '',
    tiktok:        datos.tiktok        || '',
    web:           datos.web           || '',
  });
  const [errores, setErrores] = useState({});

  const actualizar = (campo, valor) => {
    setForm(prev => ({ ...prev, [campo]: valor }));
    setErrores(prev => ({ ...prev, [campo]: '' }));
  };

  const handleNext = () => {
    const e = {};
    if (!form.nombreRecinto.trim()) e.nombreRecinto = 'Ingresa el nombre del recinto';
    if (!form.direccion.trim())     e.direccion     = 'Ingresa la dirección';
    if (!form.ciudad.trim())        e.ciudad        = 'Ingresa la ciudad';
    if (!form.zona)                 e.zona          = 'Selecciona una zona';
    if (Object.keys(e).length > 0) { setErrores(e); return; }
    onNext(form);
  };

  return (
    <div style={styles.wrap}>
      <h2 style={styles.titulo}>Datos del recinto</h2>
      <p style={styles.sub}>
        Esta información aparecerá en tu perfil público de TuRival.
      </p>

      <div style={styles.campo}>
        <label style={styles.label}>Nombre del recinto</label>
        <input
          value={form.nombreRecinto}
          onChange={e => actualizar('nombreRecinto', e.target.value)}
          placeholder="Estadio Comunal Machalí"
          style={{
            ...styles.input,
            borderColor: errores.nombreRecinto ? '#EF4444' : '#E8ECF4',
          }}
        />
        {errores.nombreRecinto && (
          <span style={styles.error}>{errores.nombreRecinto}</span>
        )}
      </div>

      <div style={styles.campo}>
        <label style={styles.label}>Dirección</label>
        <input
          value={form.direccion}
          onChange={e => actualizar('direccion', e.target.value)}
          placeholder="Av. Los Deportes 1240"
          style={{
            ...styles.input,
            borderColor: errores.direccion ? '#EF4444' : '#E8ECF4',
          }}
        />
        {errores.direccion && (
          <span style={styles.error}>{errores.direccion}</span>
        )}
      </div>

      <div style={styles.campo}>
        <label style={styles.label}>Ciudad</label>
        <input
          value={form.ciudad}
          onChange={e => actualizar('ciudad', e.target.value)}
          placeholder="Rancagua"
          style={{
            ...styles.input,
            borderColor: errores.ciudad ? '#EF4444' : '#E8ECF4',
          }}
        />
        {errores.ciudad && (
          <span style={styles.error}>{errores.ciudad}</span>
        )}
      </div>

      <div style={styles.campo}>
        <label style={styles.label}>Zona</label>
        <select
          value={form.zona}
          onChange={e => actualizar('zona', e.target.value)}
          style={{
            ...styles.select,
            borderColor: errores.zona ? '#EF4444' : '#E8ECF4',
          }}
        >
          <option value="">Selecciona tu zona</option>
          {ZONAS.map(z => <option key={z}>{z}</option>)}
        </select>
        {errores.zona && <span style={styles.error}>{errores.zona}</span>}
      </div>

      <div style={styles.campo}>
        <label style={styles.label}>Descripción breve (opcional)</label>
        <textarea
          value={form.descripcion}
          onChange={e => actualizar('descripcion', e.target.value)}
          placeholder="Ej: Complejo deportivo con 2 canchas de pasto sintético y 1 de pádel..."
          style={styles.textarea}
          maxLength={300}
        />
        <span style={styles.charCount}>{form.descripcion.length}/300</span>
      </div>

      {/* Links RRSS */}
      <div style={styles.rrssSection}>
        <div style={styles.rrssTitulo}>Links a redes sociales</div>
        <div style={styles.rrssSub}>
          Los equipos podrán visitar tus redes para ver tus instalaciones
        </div>
        {RRSS.map(({ campo, label, placeholder }) => (
          <div key={campo} style={styles.rrssRow}>
            <div style={styles.rrssLabel}>{label}</div>
            <input
              value={form[campo]}
              onChange={e => actualizar(campo, e.target.value)}
              placeholder={placeholder}
              style={styles.rrssInput}
            />
          </div>
        ))}
      </div>

      <div style={styles.botones}>
        <button style={styles.btnBack} onClick={onBack}>← Atrás</button>
        <button style={styles.btnNext} onClick={handleNext}>Siguiente →</button>
      </div>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  sub: {
    fontSize: 13, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif", marginBottom: 24, lineHeight: 1.5,
  },
  campo: { marginBottom: 16 },
  label: {
    display: 'block', fontSize: 11, fontWeight: 700,
    color: '#6B7280', textTransform: 'uppercase',
    letterSpacing: '0.05em', marginBottom: 6,
    fontFamily: "'Barlow', sans-serif",
  },
  input: {
    width: '100%', padding: '11px 14px',
    border: '1.5px solid #E8ECF4', borderRadius: 10,
    fontSize: 13, color: '#141922',
    fontFamily: "'Barlow', sans-serif",
    outline: 'none', boxSizing: 'border-box',
  },
  select: {
    width: '100%', padding: '11px 14px',
    border: '1.5px solid #E8ECF4', borderRadius: 10,
    fontSize: 13, color: '#141922',
    fontFamily: "'Barlow', sans-serif",
    outline: 'none', boxSizing: 'border-box',
    background: 'white',
  },
  textarea: {
    width: '100%', padding: '11px 14px',
    border: '1.5px solid #E8ECF4', borderRadius: 10,
    fontSize: 13, color: '#141922',
    fontFamily: "'Barlow', sans-serif",
    outline: 'none', boxSizing: 'border-box',
    resize: 'none', height: 80,
  },
  charCount: {
    fontSize: 11, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
    float: 'right', marginTop: 3,
  },
  rrssSection: {
    background: '#F4F6FA', borderRadius: 12,
    padding: '16px', marginBottom: 20,
  },
  rrssTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 15, fontWeight: 700, color: '#141922', marginBottom: 4,
  },
  rrssSub: {
    fontSize: 12, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif", marginBottom: 14,
  },
  rrssRow: {
    display: 'flex', alignItems: 'center',
    gap: 10, marginBottom: 10,
  },
  rrssLabel: {
    fontSize: 12, fontWeight: 600, color: '#4A5568',
    fontFamily: "'Barlow', sans-serif",
    minWidth: 80,
  },
  rrssInput: {
    flex: 1, padding: '8px 12px',
    border: '1.5px solid #E8ECF4', borderRadius: 9,
    fontSize: 12, color: '#141922',
    fontFamily: "'Barlow', sans-serif",
    outline: 'none', background: 'white',
  },
  error: {
    display: 'block', fontSize: 11,
    color: '#EF4444', marginTop: 4,
    fontFamily: "'Barlow', sans-serif",
  },
  botones: {
    display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10,
  },
  btnBack: {
    padding: '13px', background: 'white',
    border: '1.5px solid #E8ECF4', borderRadius: 12,
    fontSize: 14, fontWeight: 700, color: '#6B7280',
    cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  btnNext: {
    padding: '13px', background: '#FF6B1A',
    border: 'none', borderRadius: 12,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 17, fontWeight: 800,
    color: 'white', cursor: 'pointer',
  },
};